export const deeplinkPrefix = process.env.REACT_APP_DEEPLINK_PREFIX
export const deeplinkToDashboard = `${deeplinkPrefix}://dashboard`
